import React, { useContext } from 'react'
import dynamic from 'next/dynamic'
import { tag } from '@pcln/measure'
import { themeGet } from '@styled-system/theme-get'
import styled from 'styled-components'
import SearchForm from '../SearchForm'
import Hero from '../Heros/Hero'
import HeroImg from '../../assets/images/hero/pcln-hp-hero-freedom.jpg'
import ConditionalRender from '../ConditionalRender'
import ExperimentContext from '../../context/ExperimentContext'
import useSSR from '../CustomHooks/useSSR'

const DynamicHomeContent = dynamic(() => import('./HomeContent'), {
  ssr: false
})
const StaticHomeContent = dynamic(() => import('./HomeContent'))

const StyledHero = styled(Hero)`
  img {
    height: 100%;
    ${themeGet('mediaQueries.xxl')} {
      height: auto;
    }
  }
`

export default function HomeDesktop() {
  const heroProps = {
    img: `${HeroImg}?opto&auto=webp&crop=2000,800,x200,x400,safe`,
    description: 'Freedom Sale'
  }

  const { isBrowser } = useSSR()
  const { HP_DYNAMIC_IMPORT = 'DEFAULT' } = useContext(ExperimentContext)
  if (isBrowser) {
    tag('HP_DYNAMIC_IMPORT', HP_DYNAMIC_IMPORT)
  }

  return (
    <>
      <StyledHero {...heroProps}>
        <SearchForm />
      </StyledHero>
      <ConditionalRender
        experimentCode="HP_DYNAMIC_IMPORT"
        variantValue="VARIANT"
      >
        <ConditionalRender.Experiment>
          <DynamicHomeContent />
        </ConditionalRender.Experiment>
        <ConditionalRender.Original>
          <StaticHomeContent />
        </ConditionalRender.Original>
      </ConditionalRender>
    </>
  )
}
